import CryptoJS from "crypto-js";
import SessionService from "./SessionService";

abstract class CryptoService {
  public static generateAuthToken = (
    email: string,
    apiKey: string,
    sessionToken: string
  ) => CryptoJS.HmacSHA256(email + apiKey, sessionToken).toString();

  public static generateMac = (nonce: string, message?: string) => {
    const apiKey = SessionService.getApiKey();
    const authToken = SessionService.getAuthToken();
    const signature = CryptoJS.HmacSHA256(
      message === undefined ? "" : message,
      authToken
    ).toString();
    return `signature=${signature}|sessionId=${apiKey}|nonce=${nonce}`;
  };

  /**
   * This alternative function is used in cases where there may be encoding
   * issues with string, e.g. binary data.
   */
  public static generateMacFromArrayBuffer = (
    nonce: string,
    arrayBuffer: ArrayBuffer
  ) => {
    const uint8Array = new Uint8Array(arrayBuffer);
    const numberArray = Array.from(uint8Array);
    const wordArray = CryptoJS.lib.WordArray.create(numberArray);
    const apiKey = localStorage.getItem("apiKey");
    const authToken = localStorage.getItem("authToken");
    const signature = CryptoJS.HmacSHA256(wordArray, authToken!).toString();
    return `signature=${signature}|sessionId=${apiKey}|nonce=${nonce}`;
  };

  public static strEncodeUTF16 = (str: string) => {
    let bytes: number[] = [];
    for (let i = 0; i < str.length; i++) {
      let char = str.charCodeAt(i);
      bytes.push(char >>> 8);
      bytes.push(char & 0xff);
    }
    return bytes;
  };
  

  public static createXorBase64 = (pass: string, key: string) => {

    let passUTF = CryptoService.strEncodeUTF16(pass);
    let keyUTF = CryptoService.strEncodeUTF16(key);
  
    let xoring: any[] = [];
  
    for (let i = 0; i < passUTF.length; i++) {
      xoring.push(passUTF[i] ^ keyUTF[i]);
    }
  
    let xor = String.fromCharCode(...xoring);
  
    const base64 = CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(xor));
  
    return base64;
  };
  
}

export default CryptoService;
